import { IPlaneringsstatusFilter } from "./IPlaneringsstatusFilter";
import { IProduktionsstatusFilter } from "./IProduktionsstatusFilter";
import { IStatusFilter } from "./IStatusFilter";

export class StatusFilter implements IStatusFilter {
    skickadTillViol = [];
    arbetsorderAvslutad: boolean;
    extraordinarhandelse: boolean;
    planeringsstatus: IPlaneringsstatusFilter;
    produktionsstatus: IProduktionsstatusFilter;
    virkesorderstatus: [];
    schemalagd = [];
    voBehoverUppdateras = false;

    constructor() {
        this.arbetsorderAvslutad = undefined;
        this.extraordinarhandelse = undefined;
    }
}
